/* eslint-disable no-useless-escape */

/* eslint-disable no-unused-vars */

/* eslint-disable no-plusplus */

/*
Base64 编码、解码
@module util.base64
@author marsboyding@tencent.com
@date 2017-9-9
*/
var keyStr = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/='; // private method
// utf-8编码，unicode --> utf8

function utf8_encode(inputStr) {
  var str = inputStr;
  str = str.replace(/\r\n/g, '\n');
  var utftext = '';

  for (var n = 0; n < str.length; n++) {
    var c = str.charCodeAt(n);

    if (c < 0x7F) {
      utftext += String.fromCharCode(c);
    } else if (c > 0x7F && c < 0x0800) {
      utftext += String.fromCharCode(c >> 6 | 0xC0);
      utftext += String.fromCharCode(c & 0x3F | 0x80);
    } else {
      utftext += String.fromCharCode(c >> 12 | 0xE0);
      utftext += String.fromCharCode(c >> 6 & 0x3F | 0x80);
      utftext += String.fromCharCode(c & 0x3F | 0x80);
    }
  }

  return utftext;
} // utf8解码，utf8->unicode


function utf8_decode(utftext) {
  var str = '';
  var i = 0;
  var c = 0;
  var c1 = 0;
  var c2 = 0;
  var c3;

  while (i < utftext.length) {
    c = utftext.charCodeAt(i);

    if (c < 128) {
      str += String.fromCharCode(c);
      i++;
    } else if (c > 191 && c < 224) {
      c2 = utftext.charCodeAt(i + 1);
      str += String.fromCharCode((c & 0x1F) << 6 | c2 & 0x3F);
      i += 2;
    } else {
      c2 = utftext.charCodeAt(i + 1);
      c3 = utftext.charCodeAt(i + 2);
      str += String.fromCharCode((c & 15) << 12 | (c2 & 0x3F) << 6 | c3 & 0x3F);
      i += 3;
    }
  }

  return str;
} // export Object Base64


var Base64 = {
  // base64编码
  encode: function encode(inputData) {
    var output = '';
    var chr1;
    var chr2;
    var chr3;
    var enc1;
    var enc2;
    var enc3;
    var enc4;
    var i = 0;
    var input = utf8_encode(inputData);

    while (i < input.length) {
      chr1 = input.charCodeAt(i++);
      chr2 = input.charCodeAt(i++);
      chr3 = input.charCodeAt(i++);
      enc1 = chr1 >> 2;
      enc2 = (chr1 & 3) << 4 | chr2 >> 4;
      enc3 = (chr2 & 15) << 2 | chr3 >> 6;
      enc4 = chr3 & 63;

      if (isNaN(chr2)) {
        enc3 = 64;
        enc4 = 64;
      } else if (isNaN(chr3)) {
        enc4 = 64;
      }

      output = output + keyStr.charAt(enc1) + keyStr.charAt(enc2) + keyStr.charAt(enc3) + keyStr.charAt(enc4);
    }

    return output;
  },
  // base64解码
  decode: function decode(inputData) {
    var output = '';
    var chr1;
    var chr2;
    var chr3;
    var enc1;
    var enc2;
    var enc3;
    var enc4;
    var i = 0;
    var input = inputData.replace(/[^A-Za-z0-9\+\/\=]/g, '');

    while (i < input.length) {
      enc1 = keyStr.indexOf(input.charAt(i++));
      enc2 = keyStr.indexOf(input.charAt(i++));
      enc3 = keyStr.indexOf(input.charAt(i++));
      enc4 = keyStr.indexOf(input.charAt(i++));
      chr1 = enc1 << 2 | enc2 >> 4;
      chr2 = (enc2 & 15) << 4 | enc3 >> 2;
      chr3 = (enc3 & 3) << 6 | enc4;
      output = output + String.fromCharCode(chr1);

      if (enc3 != 64) {
        output = output + String.fromCharCode(chr2);
      }

      if (enc4 != 64) {
        output = output + String.fromCharCode(chr3);
      }
    }

    output = utf8_decode(output);
    return output;
  }
};
export default Base64;